import * as React from 'react'
import { CustomLinkModel } from './custom-link-model'
import { CsLockIcon } from '../../../../legacy-design-system/icons'
import { Point } from '@projectstorm/geometry'
import { css } from '@emotion/css'

const iconSize = 20

export class CustomLinkSegment extends React.Component<{
  readonly model: CustomLinkModel
  readonly path: string
}> {
  private pathRef: SVGPathElement | null
  private callback: () => void

  public componentDidMount() {
    this.callback = () => {
      if (!this.pathRef) {
        return
      }
    }

    requestAnimationFrame(this.callback)
  }

  public render() {
    const { model, path } = this.props
    const modelOptions = model.getOptions()

    const iconPoint = !model.dashed
      ? Point.middlePoint(
          Point.middlePoint(
            model.getSourcePort().getPosition(),
            model.getTargetPort().getPosition()
          ),
          model.getTargetPort().getPosition()
        )
      : undefined

    return (
      <>
        <path
          fill="none"
          ref={(ref) => {
            this.pathRef = ref
          }}
          strokeWidth={modelOptions.width}
          stroke={modelOptions.color}
          d={path}
          strokeDasharray={model.dashed ? 7 : undefined}
        />
        {!!iconPoint && (
          <CsLockIcon
            className={css`
              color: ${modelOptions.color};
            `}
            x={iconPoint.x - 30}
            y={iconPoint.y - 10}
            size={iconSize}
          />
        )}
      </>
    )
  }
}
